export interface ReportDaysRiskThresholds {
   // Classification used by code:
   highMinDays: number; // >= => High
   mediumMinDays: number; // >= => Medium (and < high)

   // Display hints (matches your attachment-2 starting values):
   lowMaxDays: number; // show "< 2 days"
   mediumHintMaxDays: number; // show "Between 3 and 4 days"
}

export const DEFAULT_REPORT_DAYS_RISK_THRESHOLDS: ReportDaysRiskThresholds = {
   highMinDays: 5,
   mediumMinDays: 3,
   lowMaxDays: 2,
   mediumHintMaxDays: 4
};
